@if (valueText()) {
    @if (backgroundColor() || foregroundColor()) {
        <bizz-conditional-bg-tag
                [value]="column().FieldType == TableFieldDataType.Numeric ? (valueText() | decimal: maxDecimals()) : valueText()"
                [backgroundColor]="backgroundColor()!"
                [foregroundColor]="foregroundColor()!">
        </bizz-conditional-bg-tag>
    } @else {
        <span class="text-sm semibold text-widget sm:text-xs">
            {{ valueText() }}
        </span>
    }
}
